import VacantestTable from './src/ReferralsTable';

export default VacantestTable;
